import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import FormatPrice from "../helper/FormatPrice";

const CartItems = (curElem) => {
  const {
    sku,
    product_id,
    qty,
    name,
    price,
    image,
    cut,
    color,
    metal,
    shape,
    style,
    clarity,
    carat,
  } = curElem;

  const {
    cartItems,
    cartItemList,
    addToCart,
    removeFromCart,
    clearCart,
    removeProduct,
    removeFromCartList,
    addToTemporaryCart,
    removeFromTemporaryCart,
    temporaryCartItems,
    setTemporaryCartItems,
    calculateTotalAmount,
  } = useContext(CartContext);

  // Initialize qty from curElem
  const initialQty = curElem.qty;

  // Retrieve cart items from local storage on component mount
  useEffect(() => {
    const storedTemporaryCartItems = JSON.parse(
      localStorage.getItem("temporaryCartItems") || "[]"
    );
    setTemporaryCartItems(storedTemporaryCartItems);
  }, []);

  const handleDeleteItem = () => {
    if (
      window.confirm("Are You Sure for Deleting Product From Temporary Cart ?")
    ) {
      const updatedTemporaryCartItems = temporaryCartItems.filter(
        (item) => item.product_id !== product_id
      );
      localStorage.setItem(
        "temporaryCartItems",
        JSON.stringify(updatedTemporaryCartItems)
      );
      setTemporaryCartItems(updatedTemporaryCartItems);
    }
  };

  const handleIncrement = () => {
    const updatedQuantity = qty + 1;
    addToTemporaryCart({ ...curElem, qty: updatedQuantity });

    const updatedTemporaryCartItems = temporaryCartItems.map((item) =>
      item.product_id === product_id ? { ...item, qty: updatedQuantity } : item
    );
    localStorage.setItem(
      "temporaryCartItems",
      JSON.stringify(updatedTemporaryCartItems)
    );
  };

  const handleDecrement = () => {
    if (qty > 1) {
      const updatedQuantity = qty - 1;
      removeFromTemporaryCart(product_id);

      const updatedTemporaryCartItems = temporaryCartItems.map((item) =>
        item.product_id === product_id
          ? { ...item, qty: updatedQuantity }
          : item
      );
      localStorage.setItem(
        "temporaryCartItems",
        JSON.stringify(updatedTemporaryCartItems)
      );
    } else {
      alert("Minimum Value Reached");
    }
  };

  return (
    <>
      <div className="row d-flex">
        <div className="col-3">
          <NavLink
            to={`/singleproduct/${sku}`}
            className="fw-bold my-2 link-dark"
          >
            <img src={image} alt="cardimg" width={200} height={200} />
          </NavLink>
        </div>
        <div className="col-6 my-2">
          <NavLink
            to={`/singleproduct/${sku}`}
            className="fw-bold my-2 link-dark"
          >
            {name} {product_id}
          </NavLink>
          <p className="my-0 text-muted">
            Carat : {carat} | Cut : {cut}
          </p>
          <p className="my-0 text-muted">
            Shape : {shape} | Color : {color}
          </p>
          <p>Price : {price}</p>
          <p className="my-2">Ring Size : </p>
          <select name="size" id="size" className="p-2">
            <option value="1">1.00</option>
            <option value="2">2.00</option>
            <option value="3">3.00</option>
            <option value="4">4.00</option>
            <option value="5">5.00</option>
          </select>
          <br />
          <p className="fw-bold mt-2">
            Made To Order.{" "}
            <span className="fw-normal">
              Estimated Ship Date: Friday, August 4th
            </span>
          </p>
        </div>
        <div className="col-2">
          <div className="cart-item-price">
            <span>
              <b>
                <FormatPrice price={price * qty} />
              </b>
            </span>
          </div>
          <p className="mb-0">Quantitiy:</p>
          <div className="cart-item-qty">
            <div>
              <button onClick={() => handleDecrement(product_id)}>-</button>
              <h6>{qty || initialQty}</h6>
              <button onClick={() => handleIncrement(product_id)}>+</button>
            </div>
          </div>
        </div>
        <div className="col-1">
          <button
            className="border-0"
            onClick={() => handleDeleteItem(product_id)}
          >
            {/* <i className="fas fa-trash"></i> */}❌
          </button>
        </div>
      </div>
      <hr className="px-2" />
    </>
  );
};

export default CartItems;
